"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CXTupleToI18nDomain = void 0;
const data_type_1 = require("../data/data-type");
const config_name_1 = require("./config-name");
const config_type_1 = require("./config-type");
/**
 * CXFamily and CXID form a combined unique identifier (CXTuple) that is an abstraction over the existing concept of
 * marketplace, which determines the ingress point of a customer. CXTuple is meant to encompass a broader set of site
 * experiences that are not restricted to just retail/marketplaces.
 * Reference: https://w.amazon.com/bin/view/INTech/CXFamilyCXId/
 *
 * I18nDomain is a remnant from a previous attempt at replacing marketplaceId, but was never fully fleshed out. In the
 * Panther space, it is used to offer variant support in PuffJ files.
 *
 * Defines the Configurations available under the CXTuple To I18nDomain mapping table.
 */
class CXTupleToI18nDomain extends config_name_1.ConfigName {
    constructor(_name, _returnType) {
        super(_name, _returnType);
    }
    getConfigType() {
        return config_type_1.ConfigType.CX_TUPLE_TO_I18N_DOMAIN;
    }
}
exports.CXTupleToI18nDomain = CXTupleToI18nDomain;
/**
 * I18nDomain is stored in string format
 */
CXTupleToI18nDomain.I18N_DOMAIN = new CXTupleToI18nDomain('i18n_domain', data_type_1.DataType.STRING);
//# sourceMappingURL=cx-tuple-to-i18n-domain.js.map